<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form" v-model="valid">
                <v-container style="max-width: 800px; padding-top: 100px">
                    <h1 class="pt-5 pb-5">Сброс пароля</h1>

                    <p class="py-3" style="font-size: 18px">Введите ваш e-mail и новый пароль для аккаунта.</p>

                    <v-layout row wrap pb-2>
                        <v-flex xs12 sm9 pt-0>
                            <v-text-field
                                v-model="email"
                                :rules="[rules.required, rules.email]"
                                label="E-mail"
                                validate-on-blur
                                required
                            ></v-text-field>
                            <v-text-field
                                :type="'password'"
                                v-model="password"
                                :rules="[rules.required,rules.newPassword]"
                                label="Новый пароль"
                                validate-on-blur
                                required
                            ></v-text-field>
                            <v-text-field
                                :type="'password'"
                                v-model="password_check"
                                :rules="[passwordCheckRule]"
                                label="Подтвердите пароль"
                                validate-on-blur
                                required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <v-layout pb-5 row wrap>
                        <v-flex xs12 sm6>
                            <v-btn @click="submit"
                                   :disabled="false"
                                   class="submit-button block">Войти</v-btn>
                        </v-flex>
                    </v-layout>

                </v-container>
            </v-form>
        </v-content>

    </v-app>
</template>

<script>
    export default {
        props: ['token'],

        data: () => ({
            valid: true,
            email: '',
            password: '',
            password_check: '',

            rules: {
                required: v => !!v || 'Обязательное поле',
                email: v => /.+@.+\..+/.test(v) || 'Неверный формат',
                newPassword: v => v.length === 0 || v.length >= 7 || 'Пароль должен содержать не менее 7 символов',
            },
        }),

        computed: {
            passwordCheckRule() {
                return () => this.password === this.password_check || 'Пароли не совпадают';
            },
        },

        methods: {
            submit() {
                if (this.$refs.form.validate()) {
                    this.submitForm();
                } else {
                    this.$nextTick(function() {
                        PNotify.error('Проверьте правильность выделенных полей.');
                        this.$vuetify.goTo('.error--text', {
                            duration: 600,
                            offset: 150,
                            easing: 'easeInCubic',
                        });
                    });
                }
            },

            submitForm() {
                axios.post(window.location.href, {
                    email: this.email,
                    password: this.password,
                    password_confirmation: this.password,
                    token: this.token,
                }).then(response => {
                    window.location.href = response.data.redirectTo;
                }).catch(error => {
                    console.log(error.response);
                    if (error.response.status === 422) {
                        PNotify.error('Не получилось обновить пароль. Проверьте правильность введенных данных.');
                    } else if (error.response.status === 419) {
                        window.location.reload();
                    } else {
                        PNotify.error('Не получилось обновить пароль. Проверьте правильность введенных данных.');
                        //PNotify.error(error.response.data.message);
                    }
                });
            },
        }
    }
</script>

<style scoped>
    .submit-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 18px !important;
        text-transform: none !important;
        box-shadow: none !important;

        height: 65px;
        background-color: #00ba57 !important;;
        text-align: center;
        display: table-cell;
        vertical-align: middle;
        padding: 0 !important;
        margin: 0;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    .submit-button >>> .v-btn__content {
        white-space: pre-wrap;
        padding: 0 70px;
        line-height: 1.1;
    }

    /deep/ h1 {
        font-size: 65px;
        font-family: 'SFPro';
        line-height: 1.1;
        font-weight: 700;
        color: #000000;
    }

    /deep/ h2, h3 {
        font-family: 'SFProBold';
    }

    /deep/ h2 {
        font-size: 28px;
    }

    /deep/ h3 {
        font-size: 20px;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/PasswordReset.vue